import React from 'react';

const DeletePonBoxConnection  = ({ flagVisiblePonBox, dataConnectionPonBox, id, deletePonBoxHouse, deletePonBoxPillar, deletePonBoxCable }) => {
  return (
    <div style={{justifyContent: 'center'}}>
      <label style={{ color: '#dfab01', display: flagVisiblePonBox ? 'block' : 'none', fontSize: "18px" }}>Связи</label>

      {flagVisiblePonBox && dataConnectionPonBox && dataConnectionPonBox.houses && dataConnectionPonBox.houses.length > 0 && (
        <>
          {dataConnectionPonBox.listConnectionPonBox.some(item => item.houseId !== null) && (
            <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
              <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./house.png' alt='вектор' />
              <label style={{ color: '#dfab01', fontSize: "18px" }}>Дом</label>
              <hr className='horizontalLine2Modal'/>
              {dataConnectionPonBox.houses.map((item, index) => {
                const connectionItem = dataConnectionPonBox.listConnectionPonBox.find(connection => connection.houseId === item.id);
                return (
                  <div className='divBodyConnectModal' key={index}> 
                    <span style={{fontWeight: 'bold'}}>ID: {connectionItem ? connectionItem.houseId : 'N/A'}</span>
                    <br/>
                    <span style={{fontSize: "14px", color: "#202020"}}>
                      {item.street}, дом. {item.house} под.{connectionItem ? connectionItem.entrance : 'N/A'}
                    </span> 
                    <br/>
                    <button className='buttonIsEditDialog' style={{width: '80px'}} onClick={() => deletePonBoxHouse(id, connectionItem.houseId)}> Удалить</button>
                  </div>
                );
              })}
            </div>
          )}
        </>
      )}

      {flagVisiblePonBox && dataConnectionPonBox && dataConnectionPonBox.listConnectionPonBox && dataConnectionPonBox.listConnectionPonBox.length > 0 && (
        <>
          {dataConnectionPonBox.listConnectionPonBox.some(item => item.pillarId !== null) && (
            <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
              <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./pillar.png' alt='вектор' />
              <label style={{ color: '#dfab01', fontSize: "18px" }}>Опора</label>
              <hr className='horizontalLine2Modal'/>
              {dataConnectionPonBox.listConnectionPonBox.map((item, index) => (
                item.pillarId !== null && (
                  <div className='divBodyConnectModal' key={index}>
                    <span style={{fontWeight: 'bold'}}>ID: {item.pillarId}</span>
                    <br/>
                    <span style={{fontSize: "14px", color: "#202020"}}>Координаты: {item.pillarLatitude}, {item.pillarLongitude}</span>
                    <br/>
                    <button className='buttonIsEditDialog' style={{width: '80px'}} onClick={() => deletePonBoxPillar(id, item.pillarId)}> Удалить</button>
                  </div>
                )
              ))}
            </div>
          )}
        </>
      )}

      {flagVisiblePonBox && dataConnectionPonBox && dataConnectionPonBox.listConnectionPonBox && dataConnectionPonBox.listConnectionPonBox.length > 0 && (
        <>
          {dataConnectionPonBox.listConnectionPonBox.some(item => item.highwayLineId !== null) && (
            <div className='divStartEndCableModal' style={{marginTop: "10px"}}>
              <img style={{marginLeft:'10px',marginRight: '10px', width: '30px', height: '30px'}} src='./cable.png' alt='вектор' />
              <label style={{ color: '#dfab01', fontSize: "18px" }}>Кабель</label>
              <hr className='horizontalLine2Modal'/>
              {dataConnectionPonBox.listConnectionPonBox.map((item, index) => (
                item.highwayLineId !== null && (
                  <div className='divBodyConnectModal' key={index}>
                    <span style={{fontWeight: 'bold'}}>ID: {item.highwayLineId}</span>
                    <br/>
                    <button className='buttonIsEditDialog' style={{width: '80px'}} onClick={() => deletePonBoxCable(id, item.highwayLineId)}> Удалить</button>
                  </div>
                )
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default DeletePonBoxConnection;